import {
  FormControlLabel,
  Grid,
  Accordion,
  AccordionDetails,
  Typography,
  useEventCallback,
  Checkbox,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { SearchPersonVM } from 'civil-status/view-models/step-form';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import ChooseDate from 'shell/components/shared/choice-date';
import { DateTime } from 'luxon';
import { DatePickerView } from '@mui/lab/DatePicker/shared';
import { ExpandMore } from '@mui/icons-material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';

interface SearchPersonProps {
  values?: SearchPersonVM;
  resetForm: () => void;
  onChange: (key: keyof SearchPersonVM, value: SearchPersonVM[keyof SearchPersonVM]) => void;
  onChanges: (values: SearchPersonVM) => void;
  onSearch: () => void;
  setOpen: (value: boolean) => void;
  open?: boolean;
  disabled?: boolean;
}

const SearchPersonComponent = ({
  values,
  onChange,
  onChanges,
  resetForm,
  onSearch,
  setOpen,
  open,
  disabled = false,
}: SearchPersonProps): React.ReactElement => {
  const handleBirthDate = useEventCallback((value?: DateTime | null, choice?: DatePickerView[]) => {
    onChanges({
      ...(values || {}),
      birthdayDate: value,
      birthdayDateChoice: choice,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-filter-person-content"
        id={`panel-filter-person-header`}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri di ricerca</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} item>
          <Grid item xs={12} md={6}>
            <PmiTextField
              label="Codice fiscale"
              aria-label="Codice fiscale"
              id="fiscalCode"
              fullWidth
              onChange={(event) => {
                onChange('fiscalCode', event?.target.value);
              }}
              value={values?.fiscalCode?.toUpperCase() || ''}
              inputProps={{ maxLength: '16' }}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <PmiTextField
              label="Cognome"
              aria-label="Cognome"
              id="surname"
              fullWidth
              onChange={(event) => {
                onChange('surname', event?.target.value);
              }}
              value={values?.surname || ''}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  id="withoutSurname"
                  checked={values?.withoutSurname || false}
                  onChange={() => onChange('withoutSurname', !values?.withoutSurname)}
                  inputProps={{ 'aria-label': 'Persona senza cognome' }}
                  disabled={disabled}
                />
              }
              label="Persona senza cognome"
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <PmiTextField
              label="Nome"
              aria-label="Nome"
              id="name"
              fullWidth
              onChange={(event) => {
                onChange('name', event?.target.value);
              }}
              value={values?.name || ''}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  id="withoutName"
                  checked={values?.withoutName || false}
                  onChange={() => onChange('withoutName', !values?.withoutName)}
                  inputProps={{ 'aria-label': 'Persona senza nome' }}
                  disabled={disabled}
                />
              }
              label="Persona senza nome"
            />
          </Grid>
          <Grid item xs={12}>
            <ChooseDate
              selected={values?.birthdayDate}
              choice={values?.birthdayDateChoice}
              onChange={handleBirthDate}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center' }}>
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                fullWidth
                onClick={onSearch}
                disabled={disabled}
              >
                Cerca
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center' }}>
              <PmiButton
                variant="outlined"
                color="cdmBrand"
                fullWidth
                onClick={resetForm}
                disabled={disabled}
              >
                Pulisci
              </PmiButton>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

SearchPersonComponent.displayName = 'Search Person component';

const SearchPerson = memo(SearchPersonComponent);

export default SearchPerson;
